import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { selectUser } from "store/auth/slice/selector";
import PageLoader from "components/PageLoader";

const PrivateRoute = ({ children }) => {
  const { user, loading } = useSelector(selectUser);
  const location = useLocation();

  if (loading) return <PageLoader fullscreen />;

  if (!user) {
    // Save intended route before redirecting to login
    sessionStorage.setItem(
      "redirectAfterLogin",
      location.pathname + location.search
    );
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;
